/* CUBE STORE - tabella taglie
   1) la nota di "Prenotabile" spezzata su due pesi;
   2) il tasto "Calcola la tua taglia" spostato nella fascia azzurra,
      con la guida che apre al posto della tabella e si chiude con un
      pulsante in fondo;
   3) all'apertura NESSUNA taglia e' scelta, e chi prova a comprare
      senza averne scelta una viene fermato con un avviso;
   4) finche' nessuna taglia e' scelta, il tasto d'acquisto parla del
      PRODOTTO e non della taglia che il tema ha scelto da solo.

   Gira anche a ogni modifica del DOM, perche' la barra di acquisto
   appiccicata clona la tabella. I guardiani dataset evitano di rifare
   due volte lo stesso lavoro, ed e' anche cio' che impedisce al
   MutationObserver di rincorrere le proprie modifiche. */
(function () {
  /* ---------- 1. la nota di "Prenotabile" ---------- */
  /* "Arrivo previsto 24/09/2026 · data indicativa" arriva dal server come
     un testo solo, dentro un <small>. Per dare due pesi diversi alle due
     parti bisogna spezzarlo, e il markup sta in blocks/buy-buttons.liquid,
     un file troppo grosso per essere riscritto da qui: si taglia qui.

     Il taglio avviene sul punto mediano, che nel testo c'e' gia'. Il
     puntino non viene ricopiato: lo rimette il CSS come ::before della
     seconda parte, cosi' se un domani cambiasse il separatore non
     resterebbe un doppio segno. */

  var SEP = ' · ';

  function dividi(nota) {
    if (nota.dataset.cubeNota === '1') return;

    var testo = nota.textContent;
    var i = testo.indexOf(SEP);
    /* le note senza separatore ("Non ordinabile", "Spedizione immediata")
       restano come sono */
    if (i === -1) return;

    nota.dataset.cubeNota = '1';

    var data = document.createElement('span');
    data.className = 'cube-arrivo';
    data.textContent = testo.slice(0, i).trim();

    var cautela = document.createElement('span');
    cautela.className = 'cube-arrivo__nota';
    cautela.textContent = testo.slice(i + SEP.length).trim();

    nota.textContent = '';
    nota.appendChild(data);
    nota.appendChild(cautela);
  }

  /* ---------- 2. la guida al posto della tabella ---------- */
  /* Al posto di "TAGLIA  DISPONIBILITA'" la fascia azzurra porta
     "CALCOLA LA TUA TAGLIA" col piu'. Aperta, la guida prende il posto
     delle taglie e del blocco di acquisto (li nasconde il CSS), e si
     chiude con il pulsante in fondo o riscliccando la fascia.

     SI SPOSTANO DUE NODI, NON SE NE CREANO
     Il pulsante entra nella fascia, il contenitore della guida - con
     dentro il pannello e l'iframe - subito sotto. Sono gli stessi nodi
     di prima: il gestore del click, lo stato aperto/chiuso e la logica
     dell'altezza restano quelli di cube-sizing.js, che non si accorge
     dello spostamento perche' tiene riferimenti diretti agli elementi.

     IL TASTO DI CHIUSURA NON SIMULA UN CLICK
     Chiude scrivendo direttamente i due valori che compongono lo stato:
     aria-expanded sul pulsante e hidden sul pannello. E' esattamente
     quello che fa cube-sizing.js, che a ogni click rilegge aria-expanded
     invece di tenersi una variabile: quindi restano allineati. Girare un
     btn.click() da un altro elemento era la strada del primo tentativo e
     produceva un doppio scatto - apriva e richiudeva nello stesso gesto.

     LO SPOSTAMENTO ASPETTA cube-sizing.js
     Si procede solo quando il pulsante ha il marchio dataset.cubeSizing,
     che quello script mette dopo aver verificato che il codice articolo
     esista, e dopo aver creato il pannello. Senza codice il configuratore
     non puo' aprirsi e il riquadro viene nascosto: in quel caso la fascia
     resta com'e', con le sue intestazioni, invece di diventare un tasto
     che non apre niente. E' anche il motivo per cui la guida sparisce
     quando il metafield custom.codice e' vuoto: non e' un guasto, e
     torna da sola appena il codice rientra.

     Le intestazioni delle colonne si perdono: e' una scelta presa
     sapendolo. */

  var CHIUDI = 'Procedi';

  function guida() {
    var wrap = document.querySelector('.vb-size-guide');
    if (!wrap) return;

    var btn = wrap.querySelector('.vb-size-guide__button');
    if (!btn || btn.dataset.cubeSizing !== '1') return;

    var head = document.querySelector('.vb-availability-card .vb-availability-head');
    if (!head || head.dataset.cubeGuida === '1') return;

    head.dataset.cubeGuida = '1';

    head.textContent = '';
    head.appendChild(btn);

    /* il contenitore va spostato DOPO aver estratto il pulsante:
       altrimenti se lo porterebbe dietro e finirebbe fuori dalla fascia */
    head.insertAdjacentElement('afterend', wrap);

    var chiudi = document.createElement('button');
    chiudi.type = 'button';
    chiudi.className = 'cube-guida-chiudi';
    chiudi.textContent = CHIUDI;

    chiudi.addEventListener('click', function (e) {
      e.preventDefault();
      btn.setAttribute('aria-expanded', 'false');
      var pannello = wrap.querySelector('.cube-sizing-panel');
      if (pannello) pannello.hidden = true;
    });

    wrap.appendChild(chiudi);
  }

  /* ---------- 3. la taglia la sceglie il cliente ---------- */
  /* Il tema apre la scheda con la PRIMA taglia gia' selezionata. Sembra
     un servizio e invece e' una trappola: chi non guarda la tabella
     compra la taglia che abbiamo deciso noi. Su una bicicletta da
     settemila euro non e' un dettaglio - e' un reso, o peggio un
     cliente che si arrabbia.

     L'AVVISO ARRIVA DOPO IL TENTATIVO, NON PRIMA
     La prima versione teneva l'avviso sempre in vista e il tasto
     spento. Funzionava, ma riempiva la pagina di un rimprovero
     preventivo a chi non aveva ancora fatto niente. Adesso la pagina
     sta zitta: il tasto sembra normale, e solo se ci si clicca senza
     aver scelto compare l'avviso. E' la stessa regola dell'acconto
     minimo in cube-importi.js - prima si prova, poi semmai si corregge.

     PERCHE' IL TASTO NON PUO' ESSERE disabled
     Un tasto spento non emette il click: il browser lo scarta prima
     che arrivi a noi, quindi non ci sarebbe niente da intercettare.
     Resta acceso e siamo noi a fermare l'invio.

     E PERCHE' NEMMENO aria-disabled
     Era il modo corretto di dire a chi non vede che il tasto non e'
     pronto, ma il tema lo veste come uno spento: opacita' 0,5,
     misurata. Il tasto tornava grigio, cioe' esattamente quello che
     si voleva togliere. La stessa informazione passa dall'avviso, che
     e' un role=status con aria-live: quando compare viene letto ad
     alta voce senza che nessuno debba andarlo a cercare.

     COME SI CAPISCE CHE HA SCELTO
     Solo da un click VERO su una riga: e.isTrusted. Non basta guardare
     se una riga ha is-selected, perche' quella classe la rimette il tema
     da solo a ogni ridisegno - al cambio di quantita', quando la barra
     appiccicata si aggiorna - e la selezione tornerebbe da sola senza
     che nessuno abbia scelto niente. Il fatto che il cliente abbia
     deciso e' una cosa che sappiamo solo noi, e ce la ricordiamo qui.

     PERCHE' IN CATTURA, E PERCHE' SI FERMA LA PROPAGAZIONE
     Il controllo va fatto prima di chiunque altro: sotto ci sono il
     gestore del tema, che aggiunge al carrello, e quello di
     cube-importi.js, che controlla l'acconto minimo. Fermando qui la
     propagazione l'ordine delle domande resta quello giusto - prima
     "che taglia?", poi "quanto di acconto?".

     L'AVVISO VA PORTATO SOTTO GLI OCCHI
     Sta sopra la riga del tasto, che e' dove il cliente sta guardando
     quando clicca. Se pero' e' fuori schermo - succede sul telefono,
     con la barra di acquisto appiccicata in basso - clicca e "non
     succede niente": per questo lo si porta in vista.

     ATTENZIONE AL TASTO DELLE SCHEDE
     .add-to-cart-button e' anche il tasto di aggiunta rapida sulle
     schede prodotto in giro per il sito: quello non c'entra, e infatti
     si saltano i pulsanti dentro .quick-add. */

  var haScelto = false;

  function tabella() {
    return document.querySelector('.vb-availability-card');
  }

  /* ==========================================================
     LA TABELLA C'E' ANCHE DOVE NON CI SONO TAGLIE
     ==========================================================
     Segnalato da Alberto Quadrio il 25 agosto 2026: "C'e' un problema
     sugli accessori, chiede la taglia", con la foto di un portaborraccia
     da 16,95 euro e la scritta "Scegli la taglia per continuare".

     E NON ERA SOLO UNA SCRITTA FUORI POSTO. Il guardiano qui sotto ferma
     il click in fase di cattura, cioe' prima di chiunque altro: quindi
     sugli accessori il pulsante non aggiungeva niente al carrello.
     Verificato cliccando davvero AGGIUNGI AL CARRELLO su quel prodotto:
     avviso a schermo e carrello fermo a ZERO articoli. Valeva per tutti
     i prodotti senza taglie - accessori, ricambi, abbigliamento a taglia
     unica - e sul sito pubblicato, non solo in anteprima.

     LA CAUSA STA IN UNA DOMANDA SBAGLIATA: il controllo chiedeva
     "c'e' la tabella?" invece di "ci sono taglie da scegliere?". La
     tabella la stampa anche l'accessorio, perche' li' serve a dire
     PRONTA CONSEGNA e a portare la guida taglie: c'e' sempre.

     IL MARCATORE ESISTEVA GIA', e questa e' la parte che fa piu'
     rabbia: il Liquid mette sulla scheda la classe
     vb-availability-card--senza-taglia esattamente in quel caso.
     Bastava guardarla.

     REGOLA DA QUI IN AVANTI: chi deve sapere "il cliente deve ancora
     scegliere qualcosa?" usa tabellaConTaglie(). tabella() risponde
     solo a "c'e' il riquadro della disponibilita'?", che e' un'altra
     domanda e ha altre risposte.
     La stessa correzione va fatta in cube-etichetta.js, che dalla
     stessa tabella ricava lo stato per i tasti: vedi li'.
     ========================================================== */

  function tabellaConTaglie() {
    var card = tabella();
    if (!card) return null;
    if (card.classList.contains('vb-availability-card--senza-taglia')) return null;
    return card;
  }

  function avviso() {
    var a = document.querySelector('.cube-scegli');
    if (a) return a;

    var fila = document.querySelector('.product-form-buttons');
    var card = tabella();
    if (!fila && !card) return null;

    a = document.createElement('p');
    a.className = 'cube-scegli';
    a.hidden = true;
    a.setAttribute('role', 'status');
    a.setAttribute('aria-live', 'polite');
    a.textContent = 'Scegli la taglia per continuare';

    if (fila && fila.parentElement) fila.parentElement.insertBefore(a, fila);
    else card.appendChild(a);

    return a;
  }

  function mostraAvviso() {
    var a = avviso();
    if (!a) return;
    a.hidden = false;

    var r = a.getBoundingClientRect();
    var fuori = r.top < 0 || r.bottom > (window.innerHeight || 0);
    if (fuori) a.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function nascondiAvviso() {
    var a = document.querySelector('.cube-scegli');
    if (a && !a.hidden) a.hidden = true;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.isTrusted || !e.target || !e.target.closest) return;

      /* ha scelto una taglia */
      if (e.target.closest('.vb-availability-item')) {
        haScelto = true;
        nascondiAvviso();
        return;
      }

      /* ha provato a comprare */
      var tasto = e.target.closest('.add-to-cart-button, .cube-azioni__tasto');
      if (!tasto || tasto.closest('.quick-add')) return;
      /* senza taglie da scegliere non c'e' niente da fermare: vedi la
         nota sugli accessori qui sopra */
      if (haScelto || !tabellaConTaglie()) return;

      e.preventDefault();
      e.stopPropagation();
      mostraAvviso();
    },
    true
  );

  function scelta() {
    /* sugli accessori non si tocca niente: la riga unica resta scelta
       com'e' arrivata dal tema, e l'avviso non viene nemmeno creato */
    var card = tabellaConTaglie();
    if (!card) return;

    var righe = card.querySelectorAll('.vb-availability-item');
    if (!righe.length) return;

    if (!haScelto) {
      righe.forEach(function (r) {
        if (r.classList.contains('is-selected')) r.classList.remove('is-selected');
      });
    }

    avviso();
  }

  /* ---------- 4. il tasto parla del prodotto, non della prima taglia ---------- */
  /* Segnalato da Alberto il 9 agosto 2026 su Reaction Hybrid Performance
     720 FE: M prenotabile, tutte le altre esaurite, e il tasto d'acquisto
     diceva ESAURITO in grigio. Chi arriva legge quello e se ne va,
     convinto che sia finita anche la M.

     Perche' succedeva: il tasto lo scrive il tema, e il tema parla della
     variante selezionata. Senza una scelta del cliente la variante e'
     quella che decide Shopify - la prima disponibile, e se nessuna lo e',
     semplicemente la prima. Con la sola M ordinabile ma bloccata (aveva
     la data di arrivo ma non il permesso di vendita a scorta zero) non
     era disponibile niente, e il tasto prendeva lo stato della S.

     La regola qui: FINCHE' NESSUNA TAGLIA E' SCELTA, il tasto dice cosa
     si puo' fare con il PRODOTTO, cioe' il meglio che offrono le sue
     taglie messe insieme:
       una taglia in pronta consegna -> resta l'etichetta del tema;
       nessuna pronta ma una prenotabile -> "Prenota";
       niente di niente -> ESAURITO, che a quel punto e' vero.

     Lo stato si legge dalla tabella che sta li' sopra - le stesse parole
     che vede il cliente - e non dai dati delle varianti: cosi' le due
     cose non possono dire il contrario l'una dell'altra.

     QUI SI USA tabella() E NON tabellaConTaglie(), ed e' voluto: un
     accessorio prenotabile esiste eccome, e il suo pulsante deve dire
     PRENOTA come quello di una bici. Qui non si chiede niente al
     cliente, si racconta soltanto cosa si puo' fare - e la riga unica
     dell'accessorio lo dice benissimo.

     Il tasto viene anche riacceso, perche' nel caso qui sopra il tema lo
     spegne. Chi ci clicca senza aver scelto trova l'avviso del punto 3,
     che e' la risposta giusta: "scegli la taglia".

     Da sapere: se una taglia e' prenotabile solo sulla carta - data di
     arrivo compilata ma vendita a scorta zero non consentita - il
     carrello la rifiutera' comunque. Questo punto raddrizza il
     messaggio, non il dato: quello si sistema in amministrazione.

     Appena il cliente sceglie, qui non si tocca piu' niente: da quel
     momento comandano il tema e i tasti della colonna. */

  var PRENOTA = 'Prenota';

  function statoProdotto() {
    var card = tabella();
    if (!card) return null;

    var righe = card.querySelectorAll('.vb-availability-item .vb-status');
    if (!righe.length) return null;

    var stato = 'esaurito';
    for (var i = 0; i < righe.length; i++) {
      var testo = (righe[i].textContent || '').toUpperCase();
      if (testo.indexOf('PRONTA') !== -1) return 'pronta';
      if (testo.indexOf('PRENOTABILE') !== -1) stato = 'prenotabile';
    }
    return stato;
  }

  function etichetta() {
    if (haScelto) return;
    if (statoProdotto() !== 'prenotabile') return;

    document.querySelectorAll('.add-to-cart-button').forEach(function (tasto) {
      if (tasto.closest('.quick-add')) return;

      var testo = tasto.querySelector('.add-to-cart-text__content') || tasto.querySelector('.add-to-cart-text');
      if (testo && testo.textContent.trim().toUpperCase() !== PRENOTA.toUpperCase()) {
        testo.textContent = PRENOTA;
      }

      if (tasto.disabled) tasto.disabled = false;
    });
  }

  /* ---------- avvio ---------- */

  function run() {
    document.querySelectorAll('.vb-availability-card .vb-status small').forEach(dividi);
    guida();
    scelta();
    etichetta();
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      run();
    });
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
